import { z } from 'zod';
import { configurationProfileSchema } from './configuration-profile.schema';

export const configurationProfilePagedCollectionSchema = z.object({
  href: z.string().nullable(),
  offset: z.number(),
  limit: z.number(),
  size: z.number(),
  data: z.array(configurationProfileSchema),
});
